<template>
  <div class="layout">
    <headernav :activeIndex="activeIndex"></headernav>
    <div class="data" id="data">
      <div class="aside-menu" :class="{ active: isShowMenu }">
        <el-tree
          ref="dataTree"
          :default-expanded-keys="defaultExpandedKeys"
          :load="loadNode"
          lazy
          accordion
          node-key="key"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :highlight-current="true"
          class="aside-inner"
        ></el-tree>
      </div>
      <div class="content" v-loading="loading">
        <div class="annexlist" v-if="file.length > 0">
          <a
            v-for="item in file"
            :key="item.id"
            :href="item.url"
            target="_blank"
          >
            <i class="iconfont icon-xiazai1"></i>
            {{ item.file_nike }}
          </a>
        </div>
        <viewer :trigger="content">
          <div v-html="content"></div>
        </viewer>
      </div>
    </div>
    <FloatNav></FloatNav>
  </div>
</template>
<script>
import headernav from "@/components/header.vue";
import FloatNav from "@/components/floatNav.vue";
import { eachDepth } from "@/utils/categoryHelp";
import { documentList, documentDetailByKeywords } from "@/api/document.js";
export default {
  data() {
    return {
      loading: false,
      hasMenubg: false,
      isShowMenu: false,
      activeIndex: "",
      selectedId: "",
      keyword: "",
      isCollapse: false,
      defaultExpandedKeys: [],
      content: "",
      file: [],
      subMenu: [],
      menuData: [],
      defaultProps: {
        label: "label",
        isLeaf: "isLeaf",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    let cKeywords = to.params.cKeywords;
    let docKeywords = to.params.docKeywords;
    next((vm) => {
      vm.docKeywords = docKeywords;
      vm.init(cKeywords);
    });
  },
  beforeRouteUpdate(to, from, next) {
    let cKeywords = to.params.cKeywords;
    this.docKeywords = to.params.docKeywords;
    this.init(cKeywords);
    next();
  },
  components: {
    headernav,
    FloatNav,
  },
  methods: {
    async init(cKeywords) {
      // 默认展开
      if (this.docKeywords) {
        // 指定文档
        this.loadDocumentDetail(this.docKeywords, (document) => {
          let showCategory = this.$tools.category.getById(
            document.document_category
          );
          let c_idPath = [];
          showCategory.id_path.forEach((x) => {
            c_idPath.push(`c_${x}`);
          });
          this.defaultExpandedKeys = c_idPath;
          this.selectedId = document.document_id;
        });
      } else {
        this.isSetExpand = true;
        this.cKeywords = cKeywords;

        // 默认第一个文档
        let showCategory = this.getDefaultCategoryIdPath(
          this.$tools.category.getByKey(cKeywords)
        );
        this.loadDocument(showCategory.defaultCategoryId, 1, (list) => {
          if (list.length > 0) {
            let document = list[0];
            this.loadDocumentDetail(document.document_keywords);
            this.selectedId = document.document_id;
          } else {
            this.selectedId = showCategory.c_idPath;
          }
        });
      }
    },
    convertToNode(node, isCategory) {
      return {
        key: `c_${node.category_id}`,
        categoryId: node.category_id,
        keywords: node.category_keywords,
        label: node.category_name,
        isCategory: isCategory,
        isLeaf: false,
      };
    },
    getDefaultCategoryIdPath(category, defaultObj) {
      if (defaultObj) {
        defaultObj.defaultCategoryId = category.category_id;
        defaultObj.idPath.push(category.category_id);
        defaultObj.c_idPath.push(`c_${category.category_id}`);
      } else {
        defaultObj = {
          defaultCategoryId: category.category_id,
          idPath: [category.category_id],
          c_idPath: [`c_${category.category_id}`],
        };
      }
      if (category.child.length > 0) {
        defaultObj = this.getDefaultCategoryIdPath(
          category.child[0],
          defaultObj
        );
      }
      return defaultObj;
    },
    loadNode(node, resolve) {
      let result = [];
      let category;

      if (node.level === 0) {
        // 根节点
        category = this.$tools.category.getByKey(
          this.$cfg.categoryKeyForDocument
        );
      } else if (node.data.isCategory) {
        // 子分类
        category = this.$tools.category.getByKey(node.data.keywords);
      }

      if (category && category.child.length > 0) {
        // 加载分类
        for (var item of category.child) {
          result.push(this.convertToNode(item, true));
        }
        return resolve(result, 1);
      } else {
        this.loadDocument(node.data.categoryId, 999, (list) => {
          if (list.length > 0) {
            for (var item of list) {
              result.push({
                key: item.document_id,
                categoryId: item.document_category,
                label: item.document_title,
                keywords: item.document_keywords,
                isCategory: false,
                isLeaf: true,
              });
            }
          }
          return resolve(result);
        });
      }
    },
    loadDocument(categoryId, pageSize, callBack) {
      this.loading = true;
      // 加载文章
      let query = {
        category_id: categoryId,
        page_number: 1,
        page_size: pageSize || 1,
      };
      documentList(query).then((resp) => {
        callBack(resp.data.list);
        this.loading = false;
      });
    },
    handleNodeClick(data) {
      if (!data.isCategory) {
        if (data.key && data.keywords != this.docKeywords) {
          this.content = "";
          this.$router.push(`/document/detail/${data.keywords}`).catch((e) => {
            console.log(e);
          });
        }
      }
    },
    loadDocumentDetail(keywords, callBack) {
      documentDetailByKeywords(keywords).then((resp) => {
        this.content = resp.data.document_content;
        this.file = resp.data.file;
        if (callBack) {
          callBack(resp.data);
        }
      });
    },
    changeMenuCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
  updated() {
    this.$nextTick(function () {
      if (this.isSetExpand && this.$refs.dataTree) {
        let tree = this.$refs.dataTree;
        let firstCategoryList = this.$tools.category.getByKey(
          this.$cfg.categoryKeyForDocument
        );

        let showCategory = this.getDefaultCategoryIdPath(
          this.$tools.category.getByKey(this.cKeywords)
        );

        eachDepth(firstCategoryList.child, (x) => {
          var item = tree.store.getNode(`c_${x.category_id}`);
          if (item !== null && item.collapse) {
            item.collapse();
          }
        });
        this.defaultExpandedKeys = showCategory.c_idPath;
        this.isSetExpand = false;
      }
    });
  },
};
</script>
